import axios from "@shared/axios";
import News from "@shared-models/box/news.model";
import NewsListInterface from "@shared-interfaces/box/news.list.interface";

async function getNewsList(): Promise<NewsListInterface>
{
	const response = await axios.get("/box/news");

	return response?.data as NewsListInterface ?? { data: {}, unread: 0 };
}

async function getNewsById(newsId: string): Promise<News>
{
	const response = await axios.get(`/box/news/${ newsId }`);

	return response?.data as News ?? null;
}

async function getUnreadNewsCount(): Promise<number>
{
	const response = await axios.get("/box/news/unread-count");

	return response?.data ?? null;
}

export {
	getNewsList,
	getNewsById,
	getUnreadNewsCount
};
